import { animated, easings, useSpring } from "@react-spring/web";

import { ARTWORK_PROCESSING } from "@design-lab/shared/constants";
import { ProgressBar } from "@design-lab/shared/ui";

type CustomLoadingBarProps = {
  startTime?: number;
};

export function CustomLoadingBar({ startTime }: CustomLoadingBarProps) {
  // Calculate progress for loading state
  const elapsed = startTime ? Math.max(0, Date.now() - startTime) : 0;
  const start = startTime ? Math.min(1, elapsed / ARTWORK_PROCESSING.ESTIMATED_DURATION) : 0;

  const { progressPercentage } = useSpring({
    from: { progressPercentage: start * 100 },
    to: { progressPercentage: startTime ? 98 : start * 100 },
    config: {
      duration: startTime ? ARTWORK_PROCESSING.ESTIMATED_DURATION : 0,
      mass: 2,
      tension: 300,
      friction: 15,
      easing: easings.easeOutQuad
    }
  });
  const AnimatedProgressBar = animated(ProgressBar);
  return (
    <div className="flex flex-col items-center gap-4">
      <div className="space-y-2 text-center">
        <p className="text-center text-lg font-semibold leading-[28px] text-gray-900">
          Uploading image
        </p>
        <div className="flex justify-center">
          <p className="w-64 text-center text-sm font-normal leading-[20px] text-gray-500">
            <animated.span>
              {progressPercentage.to(v => `${Math.round(v)}% (Less than 1 minute remaining)`)}
            </animated.span>
          </p>
        </div>
      </div>

      <div className="w-full max-w-md">
        <AnimatedProgressBar value={progressPercentage} />
      </div>
    </div>
  );
}
